/**
 * TanStack Query hooks for `openapi-spec-sdks-node-python-go-php-ruby`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	openapiSpecSdksNodePythonGoPhpRubyQueryKeys,
	type CreateOpenapiSpecSdksNodePythonGoPhpRubyBody,
	type ListOpenapiSpecSdksNodePythonGoPhpRubyResponse,
	type OpenapiSpecSdksNodePythonGoPhpRubyRow,
} from "./api";

export function useOpenapiSpecSdksNodePythonGoPhpRubyList(): UseQueryResult<ListOpenapiSpecSdksNodePythonGoPhpRubyResponse, Error> {
	return useQuery({
		queryKey: openapiSpecSdksNodePythonGoPhpRubyQueryKeys.list(),
		queryFn: list,
	});
}

export function useOpenapiSpecSdksNodePythonGoPhpRubyCreate(): UseMutationResult<OpenapiSpecSdksNodePythonGoPhpRubyRow, Error, CreateOpenapiSpecSdksNodePythonGoPhpRubyBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: openapiSpecSdksNodePythonGoPhpRubyQueryKeys.all });
		},
	});
}

export function useOpenapiSpecSdksNodePythonGoPhpRubyDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: openapiSpecSdksNodePythonGoPhpRubyQueryKeys.all });
		},
	});
}
